<template>
  <div class="content">
    <div class="rotation">
      <div class="rotation_content">
          <el-form :label-position="labelPosition" :rules="rules" label-width="150px" :model="form">
            <el-form-item label="作业名称" prop="name">
              <el-input v-model="form.name" placeholder="请输入作业名称"></el-input>
            </el-form-item>
            <el-form-item label="作业设置">
              <ul class="exam_set">
                <li v-for="(item,index) in setList" :key="index">
                  <div class="exam_set_left" v-if="item.type === 1">判断题</div>
                  <div class="exam_set_left" v-else-if="item.type === 2">单选题</div>
                  <div class="exam_set_left" v-else-if="item.type === 3">多选题</div>
                  <div class="exam_set_left" v-else-if="item.type === 4">问答题</div>
                  <div class="exam_set_right">
                      <span>数量</span>
                      <el-input v-model="item.num" v-if="item.type === 1" placeholder="请输入判断题数量" @change="changeNum(item,'judge')"></el-input>
                      <el-input v-model="item.num" v-else-if="item.type === 2" placeholder="请输入单选题数量" @change="changeNum(item,'radio')"></el-input>
                      <el-input v-model="item.num" v-else-if="item.type === 3" placeholder="请输入多选题数量" @change="changeNum(item,'checkbox')"></el-input>
                      <el-input v-model="item.num" v-else-if="item.type === 4" placeholder="请输入问答题数量" @change="changeNum(item,'qa')"></el-input>
                  </div>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="判断题选择" v-if="judgeShow">
              <el-transfer
                filterable
                :filter-method="judgeFilter"
                filter-placeholder="请输入题目名称"
                v-model="judgeValue"
                :titles="['判断题题目', '已选题目']"
                :data="judgeList">
              </el-transfer>
            </el-form-item>
            <el-form-item label="单选题选择" v-if="radioShow">
              <el-transfer
                filterable
                :filter-method="radioFilter"
                filter-placeholder="请输入题目名称"
                v-model="radioValue"
                :titles="['单选题题目', '已选题目']"
                :data="radioList">
              </el-transfer>
            </el-form-item>
            <el-form-item label="多选题选择" v-if="checkboxShow">
              <el-transfer
                filterable
                :filter-method="checkboxFilter"
                filter-placeholder="请输入题目名称"
                v-model="checkboxValue"
                :titles="['多选题题目', '已选题目']"
                :data="checkboxList">
              </el-transfer>
            </el-form-item>
            <el-form-item label="问答题选择" v-if="QAshow">
              <el-transfer
                filterable
                :filter-method="qaFilter"
                filter-placeholder="请输入题目名称"
                v-model="QAValue"
                :titles="['问答题题目', '已选题目']"
                :data="QAList">
              </el-transfer>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit">保存</el-button>
            </el-form-item>
        </el-form>  
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'addTask',
  components:{
  },
  data(){
    return {
      rules:{
        category :[{required: true, message: '请选择所属类别', trigger: 'change'}],
        name :[{required: true, message: '请输入作业名称', trigger: 'blur'}],
      },
      labelPosition:'right',
      form: {
        category:'',
        name: '',
      },
      setList:[{type:1,num:''},{type:2,num:''},{type:3,num:''},{type:4,num:''}],
      judgeList:[],
      radioList:[],
      checkboxList:[],
      QAList:[],
      judgeValue:[],
      radioValue:[],
      checkboxValue:[],
      QAValue:[],
      judgeShow:false,
      radioShow:false,
      checkboxShow:false,
      QAshow:false,
      judgeKeywords:'',
      radioKeywords:'',
      checkboxKeywords:'',
      QAKeywords:'',
    }
  },
  created(){
    
    
  },
  mounted(){
    this.changeType()
  },
  methods:{
    getSelect(params){
      this.$api.user.taskSubjectSelect(params)
      .then(res=>{
        if(res.code === 0){
          let arr = res.result
          let newSArr = []
          arr.forEach(function(v,k){
            newSArr.push({
              key:v.id,
              label:v.name,
              disabled:false
            })
          })
          if(params.type === 1){
            this.judgeList  = newSArr
          }
          if(params.type === 2){
            this.radioList  = newSArr
          }
          if(params.type === 3){
            this.checkboxList  = newSArr
          }
          if(params.type === 4){
            this.QAList  = newSArr
          }
        }
      })
    },
    changeType(){
      let arr = [1,2,3,4]
      let that = this
      arr.forEach(function(v){
        let params = {
          category:that.form.category,
          type:v,
          name:""
        }
        that.getSelect(params)
      })
    },
    changeNum(item,text){
      if(Number(item.num) > 0 && Number(item.num)){
        if(text === 'judge'){
          this.judgeShow = true
        }
        if(text === 'radio'){
          this.radioShow = true
        }
        if(text === 'checkbox'){
          this.checkboxShow = true
        }
        if(text === 'qa'){
          this.QAshow = true
        }
      }else if(Number(item.num) <= 0){
        if(text === 'judge'){
          this.judgeShow = false
          this.judgeValue = []
        }
        if(text === 'radio'){
          this.radioShow = false
          this.radioValue = []
        }
        if(text === 'checkbox'){
          this.checkboxShow = false
          this.checkboxValue = []
        }
        if(text === 'qa'){
          this.QAshow = false
          this.QAValue = []
        }
      }
    },
    judgeFilter(query, item) {
      if(query != this.judgeKeywords){
        this.judgeKeywords = query
        let params = {
          type:1,
          name:query
        }
        this.$api.user.taskSubjectSelect(params)
        .then(res=>{
          if(res.code === 0){
            let arr = res.result
            let newSArr = []
            arr.forEach(function(v){
              newSArr.push({
                key:v.id,
                label:v.name,
                disabled:false
              })
            })
            this.judgeList  = newSArr
          }
        })
      }
      return this.judgeList
    },
    radioFilter(query, item) {
     if(query != this.radioKeywords){
        this.radioKeywords = query
        let params = {
          type:2,
          name:query
        }
        this.$api.user.taskSubjectSelect(params)
        .then(res=>{
          if(res.code === 0){
            let arr = res.result
            let newSArr = []
            arr.forEach(function(v){
              newSArr.push({
                key:v.id,
                label:v.name,
                disabled:false
              })
            })
            this.radioList  = newSArr
          }
        })
        
      }
      return this.radioList
    },
    checkboxFilter(query, item) {
     if(query != this.checkboxKeywords){
        this.checkboxKeywords = query
        let params = {
          type:3,
          name:query
        }
        this.$api.user.taskSubjectSelect(params)
        .then(res=>{
          if(res.code === 0){
            let arr = res.result
            let newSArr = []
            arr.forEach(function(v){
              newSArr.push({
                key:v.id,
                label:v.name,
                disabled:false
              })
            })
            this.checkboxList  = newSArr
          }
        })
        
      }
      return this.checkboxList
    },
    qaFilter(query, item) {
     if(query != this.QAKeywords){
        this.QAKeywords = query
        let params = {
          type:4,
          name:query
        }
        this.$api.user.taskSubjectSelect(params)
        .then(res=>{
          if(res.code === 0){
            let arr = res.result
            let newSArr = []
            arr.forEach(function(v){
              newSArr.push({
                key:v.id,
                label:v.name,
                disabled:false
              })
            })
            this.QAList  = newSArr
          }
        })
        
      }
      return this.QAList
    },
    onSubmit(){
      let settingarr = [],questionarr = []
      let judge = true ,radio = true,check = true,qa = true
      this.setList.forEach(function(v,k){
        if(Number(v.num) != 0){
          settingarr.push(v)
        }
      })
      if(this.judgeShow){
        if(this.judgeValue.length === Number(this.setList[0].num)){
          questionarr.push({type:1,question:(this.judgeValue)})
        }else{
          judge = false
          this.$message.error('所选判断题数目和作业设置中的不同，请查看')
        }
      }else{
        judge = false
      }
      if(this.radioShow){
        if(this.radioValue.length === Number(this.setList[1].num)){
          questionarr.push({type:2,question:(this.radioValue)})
        }else{
          radio = false
          this.$message.error('所选单选题数目和作业设置中的不同，请查看')
        }
      }else{
        radio = false
      }
      if(this.checkboxShow){
        if(this.checkboxValue.length === Number(this.setList[2].num)){
          questionarr.push({type:3,question:(this.checkboxValue)})
        }else{
          check = false
          this.$message.error('所选多选题数目和作业设置中的不同，请查看')
        }
      }else{
        check = false
      }
      if(this.QAshow){
        if(this.QAValue.length === Number(this.setList[3].num)){
          questionarr.push({type:4,question:(this.QAValue)})
        }else{
          qa = false
          this.$message.error('所选问答题数目和作业设置中的不同，请查看')
        }
      }else{
        qa = false
      }
      if(this.judgeShow === judge && this.radioShow === radio && this.checkboxShow === check && this.QAshow ===qa){
        let params = {
          category: this.form.category, 
          name: this.form.name,
          duration:this.form.duration,
          setting:JSON.stringify(settingarr),
          question:JSON.stringify(questionarr),
        }
        if(!this.form.name){
          this.$message.error('请输入作业名称');
        }else if(settingarr.lenght <= 0){
          this.$message.error('请设置作业');
        }else if(questionarr.lenght <= 0){
          this.$message.error('请选择题目');
        }else{
          this.$api.user.taskAdd(params)
            .then(res=>{
              if(res.code === 0){
                this.$message.success('添加作业成功')
                this.$router.replace({
                  path:'/task/task'
                })
              }
            }) 
          }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
  @import '../../assets/scss/content.scss';
  @import '../../assets/scss/exam.scss';
</style>
